





































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { ShoppingCart } from '../types/types';
import _ from 'lodash';
const cssPrefix = 'checkOutShoppingCart';
@Component({
  components:{
    ...UUIFComponents,
  },
})
export default class CheckOutShoppingCart extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop()
  shoppingCart: any;

  @Watch('shoppingCart', { deep: true })
  private onChangeValues() {
    this.shoppingCartObject = !_.isNull(this.shoppingCart) && !_.isEmpty(this.shoppingCart) ?
      { ...this.shoppingCart } : {};
  }

  shoppingCartObject: ShoppingCart = {};

  get getShoppingCart() : ShoppingCart {
    return this.shoppingCartObject;
  }

  created() {
    this.shoppingCartObject = !_.isNull(this.shoppingCart) && !_.isEmpty(this.shoppingCart) ?
      { ...this.shoppingCart } : {};
  }
}
